<script >
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import EditIcon from "../../icons/EditIcon.vue";
import Switcher from "../../small_components/Switcher.vue";
import AsideDashboard from "../../small_components/AsideDashboard.vue";
import HeaderBlock from "../../parts/HeaderBlock.vue";
import NotifierBlock from "../../parts/NotifierBlock.vue";
import {
  axiosBelts,
  axiosBeltsCookie,
  axiosBenefits,
  axiosCommittees,
  axiosUsers
} from "../../../helpers/axios_requests";
import calendar_mixin from "../../../mixins/calendar_mixin";
import routes_mixin from "../../../mixins/routes_mixin";
import InfoBlock from "../../small_components/InfoBlock.vue";
import ChevronLeftIcon from "../../icons/ChevronLeftIcon.vue";
import Loader from "../../small_components/Loader.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import {ROUTES_NAMES} from "../../../router";
import {mapActions} from "vuex";
import {NEW_COMMITTEE, NEW_COOKIE} from "../../../helpers/new_objects";

export default {
  mixins: [calendar_mixin, routes_mixin],

  name: 'CookieView',
  components: {
    DefaultButton,
    BadgeBlock, DefaultTitle,
    DefaultInput,
    Loader, ChevronLeftIcon, InfoBlock,
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,

  },

  computed: {
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      cookie: [],
      new_cookie: false
    }
  },

  created() {
    this.loading = false;
    this.fetchCookie(this.$route.params.id)
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.cookie = data || [];
    },

    fetchCookie(id) {
      this.loading = true
      if (id == 0) {
        this.$set(this, 'cookie', NEW_COOKIE())
        this.$set(this, 'new_cookie', true)
        this.loading = false
        return
      }
      this.loading = true
      axiosBeltsCookie.item(id)
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },

    createUpdate() {
      axiosBeltsCookie.createUpdate(this.cookie)
          .then((r) => {
            if (r.data.errors) {
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
            if (this.new_cookie) {
              this.$router.push({name: ROUTES_NAMES.benefit_cookies})
            }
          }).catch((r) => {
        console.log(r)
      })
    }
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{$t('belts.belt_info')}}
      </default-title>
      <default-box class="position-relative"
                :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{$t('belts.belt')}} {{ cookie.title }}</h5>
              <div class="card-body">
                <form class="row mt-20"
                      @submit.prevent="createUpdate"
                >
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        required
                        :label="$t('tables.title')"
                        v-model="cookie.title"
                    />
                    <div class="text-end mt-20 sticky-bottom">
                      <default-button
                          button_large
                          type="submit">
                        {{ $t('inputs.save') }}
                      </default-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>


</template>

<style scoped>

</style>